let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dJnPF")).then(() => parcelRequire('hNUo7'));